"use client";

import { useSyncExternalStore } from "react";

// Same breakpoint as Tailwind's `lg:` (64rem), so `lg:hidden` / `hidden lg:block`
// and this hook always agree.
const DESKTOP_QUERY = "(min-width: 64rem)";

const subscribe = (onChange) => {
	const mql = window.matchMedia(DESKTOP_QUERY);
	mql.addEventListener("change", onChange);
	return () => mql.removeEventListener("change", onChange);
};

const getSnapshot = () => window.matchMedia(DESKTOP_QUERY).matches;

// null on the server and during hydration: the caller renders both the mobile and
// the desktop tree (as before, so SSR HTML and crawlers keep both), then React
// re-renders with true/false right after hydration and the hidden tree is dropped.
// Unlike useIsMobile, this never guesses a device on the server.
const getServerSnapshot = () => null;

export default function useIsDesktop() {
	return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
